import { useEffect, useState } from 'react'
import { captureAttribution, getFormAttributionPayload } from '@/lib/attribution'

export default function AttributionHiddenFields() {
  const [fields, setFields] = useState({})

  useEffect(() => {
    captureAttribution()
    const payload = getFormAttributionPayload()
    const next = {}
    Object.keys(payload).forEach((key) => {
      if (key === 'touches' || key === 'submitted_at') return
      if (payload[key] == null || payload[key] === '') return
      next[key] = String(payload[key])
    })
    setFields(next)
  }, [])

  return Object.keys(fields).map((name) => (
    <input key={name} type="hidden" name={name} value={fields[name]} readOnly />
  ))
}
